// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deal-detail .van-uploader__upload{margin:0}.deal-detail .van-dialog__message{font-size:20px}", ""]);
// Exports
module.exports = exports;
